export const DISPLAYED_VICTORIES = 6;
